import { render, staticRenderFns } from "./OperadoraRegraCirurgia.vue?vue&type=template&id=0d6b1273&"
import script from "./OperadoraRegraCirurgia.vue?vue&type=script&lang=js&"
export * from "./OperadoraRegraCirurgia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports